module.exports = __webpack_public_path__ + "static/media/icon-peru.cd02728e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/featured-cards/icons/icon-peru.png
// module id = 2224
// module chunks = 0